var _excluded = ["onChange"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import PropTypes from 'prop-types';
import React from 'react';

var noop = function noop() {};

export default (function (Component) {
  var BoundWrapper = function BoundWrapper(props, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === void 0 ? {} : _ref$value,
        _ref$errors = _ref.errors,
        errors = _ref$errors === void 0 ? {} : _ref$errors,
        _onChange = _ref.onChange;

    var onChangeProp = props.onChange,
        rowProps = _objectWithoutProperties(props, _excluded);

    return /*#__PURE__*/React.createElement(Component, _extends({
      value: typeof value[props.name] === 'undefined' ? '' : value[props.name],
      feedback: errors[props.name] || '',
      onChange: function onChange(e) {
        onChangeProp(e);

        _onChange(props.name)(e);
      }
    }, rowProps));
  };

  BoundWrapper.contextTypes = {
    value: PropTypes.object,
    errors: PropTypes.object,
    onChange: PropTypes.func
  };
  BoundWrapper.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func
  };
  BoundWrapper.defaultProps = {
    onChange: noop
  };
  return BoundWrapper;
});